module.exports = __webpack_public_path__ + "static/media/ajax-Loader.b30047d3.gif";